import Cookies from "js-cookie"
let Base64 = require("js-base64").Base64

const TokenKey = "token"

export function getToken(share) {
  return share ? localStorage.getItem(share) : Cookies.get(TokenKey)
}

export function setToken(token, share) {
  return share
    ? localStorage.setItem(share, token)
    : Cookies.set(TokenKey, token, { expires: 30, sameSite: "lax", secure: false }) // expires 2 days from now
}

export function removeToken(share) {
  return share ? localStorage.removeItem(share) : Cookies.remove(TokenKey)
}

/**
 * Parser userInfo from token
 * @param {String} token
 * @returns {Object} userInfo
 */
export function getUserInfo(token) {
  try {
    let payload = JSON.parse(Base64.decode(token.split(".")[1]))
    return JSON.parse(payload.sub)
  } catch (err) {
    return false
  }
}
